module.exports = __webpack_public_path__ + "img/linkedin.6c9a19b0.svg";